import { useState } from 'react';

import useFetch from 'hooks/useFetch';
import useRetry from 'hooks/useRetry';

import { CONNECTION_ERROR, MAPS_API } from './constants';
import type {
    ExportMapLayer,
    ExportMapLayerRequest,
    ExportMapLayerResponse,
    UseJohnDeereMapExportReturn
} from './types';

const useJohnDeereMapExport = (): UseJohnDeereMapExportReturn => {
    const [isExporting, setIsExporting] = useState(false);

    const { authenticatedPostFormData } = useFetch({
        apiHost: import.meta.env.VITE_JD_API_BASE_URL || '',
        headers: { 'Content-Type': 'application/json' }
    });

    const { withRetry } = useRetry();

    const exportMapLayer: ExportMapLayer = async request => {
        try {
            setIsExporting(true);

            const formData = buildFormData(request);

            return await withRetry(
                () => authenticatedPostFormData<ExportMapLayerResponse>(MAPS_API, formData),
                CONNECTION_ERROR,
                () => exportMapLayer(request)
            );
        } finally {
            setIsExporting(false);
        }
    };

    return {
        exportMapLayer,
        isExporting
    };
};

const buildFormData = (request: ExportMapLayerRequest): FormData => {
    const { image, ...rest } = request;

    const formData = new FormData();

    formData.append('metadata', JSON.stringify(rest));
    formData.append('image', image);

    return formData;
};

export default useJohnDeereMapExport;
